<template>
  <div>
    <span> By clicking <strong>I Accept</strong> below, I: </span>
    <ul>
      <li>
        accept this Novated Lease Quote and authorise {{ entity }} to arrange
        for the purchase the vehicle described in the Novated Lease Quote
        (Vehicle);
      </li>
      <li>
        understand that if I cancel the Vehicle purchase I may incur costs;
      </li>
      <li>
        ask {{ entity }} to lease the Vehicle to me and agree to novate the
        Lease to my employer;
      </li>
      <li>
        understand that I will be liable to pay the residual value of the
        Vehicle at the end of the Lease;
      </li>
      <li>
        understand the tax implications of a novated lease and have had the
        opportunity to seek independent financial and tax advice, and I have not
        relied on any representations by {{ entity }} in relation to these
        matters;
      </li>
      <li>
        acknowledge that in the event of a variation in the purchase price
        (including dealer delivery charges, goods and services tax, stamp duty)
        payable by {{ entity }} for the Vehicle and/or any interest rate
        variation, {{ entity }} will adjust the lease rental accordingly and
        notify me of that variation;
      </li>
      <li>
        understand that a novated lease arrangement is subject to FBT
        legislation; and
      </li>
      <li>
        confirm that I have read and understood the relevant Product Disclosure
        Statement and Target Market Determination relating to any insurance
        product included in the Novated Lease Quote.
      </li>
    </ul>
    <span>
      When an electric vehicle FBT exemption applies to a vehicle, the value of
      the exemption is still a reportable fringe benefits amount for tax
      purposes and will be taken into account in calculating liabilities and
      entitlements. We recommend you seek independent financial advice.
    </span>
  </div>
</template>

<script>
export default {
  name: 'QuoteAcceptanceCopyConfirmation',
  props: {
    entity: String,
  }
};
</script>

<style lang="sass" scoped>
.latin-decoration
  list-style-type: lower-alpha
</style>
